const PWD_POLICY = [
  {
    descDE: 'Mindestens 1 Kleinbuchstabe',
    showRule: true,
    check (pwd) {
      return pwd && (pwd.match(/[a-z]/g) || []).length > 0
    }
  },
  {
    descDE: 'Mindestens 1 Großbuchstabe',
    showRule: true,
    check (pwd) {
      return pwd && (pwd.match(/[A-Z]/g) || []).length > 0
    }
  },
  {
    descDE: 'Mindestens 1 Zahl',
    showRule: true,
    check (pwd) {
      return pwd && (pwd.match(/[0-9]/g) || []).length > 0
    }
  },
  {
    descDE: 'Mindestens 8-99 Zeichen',
    showRule: true,
    check (pwd) {
      return pwd && (pwd.length >= 8 && pwd.length < 100)
    }
  },
  {
    descDE: 'Erlaubte Sonderzeichen + - ^ $ * . [ ] { } ( ) ? " ! @ # % & / \\ , > < \' : ; | _ ~ ` =',
    showRule: false,
    errorMsgDE: 'Unerlaubtes Sonderzeichen',
    check (pwd) {
      return pwd && (pwd.match(/[^A-Za-z0-9+\-^$*.[\]{}()?"!@#%&/\\,<>':;|_~=']/g)?.length || 0) === 0
    }
  }
]

export default {
  policy: PWD_POLICY
}
